import { Chip, ListBox, Select } from "@heroui/react";
import { getDocsVersionsList } from "@/config/docs-config";

const InfoRow = ({ label, value }) => (
  <div className="flex items-center gap-2">
    <Chip className="bg-surface-secondary text-muted border border-separator" size="sm">
      <Chip.Label>{label}</Chip.Label>
    </Chip>
    <Chip className="bg-accent/10 dark:bg-white/60 text-accent">
      <Chip.Label className="font-mono text-xs">{value}</Chip.Label>
    </Chip>
  </div>
);

const DocsPageBanner = ({ title, description, version, onVersionChange, meta }) => {
  const versions = getDocsVersionsList();

  return (
    <div className="flex flex-col items-start">
      <div className="flex items-center gap-2">
        <Chip className="bg-accent/10 dark:bg-white/60 text-accent">
          <Chip.Label>API DOCS</Chip.Label>
        </Chip>

        <Select selectedKey={version} onSelectionChange={(key) => onVersionChange?.(String(key))} placeholder="Version">
          <Select.Trigger className="h-7 w-[70px] flex items-center min-h-0 py-1 px-2 gap-1 rounded-lg border border-border bg-surface">
            <span className="text-xs">{versions.find((v) => v.key === version)?.label ?? version}</span>
            <Select.Indicator />
          </Select.Trigger>
          <Select.Popover>
            <ListBox>
              {versions.map(({ key, label }) => (
                <ListBox.Item key={key} id={key} textValue={label}>
                  {label}
                  <ListBox.ItemIndicator />
                </ListBox.Item>
              ))}
            </ListBox>
          </Select.Popover>
        </Select>

        <Chip className="bg-warning/15 text-warning border border-warning/30">
          <Chip.Label className="text-xs font-semibold">BETA</Chip.Label>
        </Chip>
      </div>

      <div className="flex flex-col mt-1">
        <span className="font-black text-glass-foreground text-3xl">{title}</span>
        <span className="text-glass-foreground-muted font-bold">API Documentation</span>
      </div>

      <p className="text-glass-foreground text-xs font-medium mt-2 max-w-prose">{description}</p>

      {meta && (
        <div className="mt-4 flex flex-col gap-2">
          <InfoRow label="Base URL" value={meta.baseUrl} />
          <InfoRow label="Auth" value={meta.auth} />
          <InfoRow label="Content-Type" value={meta.contentType} />
        </div>
      )}
    </div>
  );
};

export default DocsPageBanner;
